import angular from 'angular';
import base64Upload from 'angular-base64-upload';
import FileUploadController from './file-upload.controller';
import template from './file-upload.pug';

export default angular
  .module('verifyApp.fileUpload', [base64Upload])
  .directive('fileUpload', () => ({
    template,
    restrict: 'E',
    controller: FileUploadController,
    controllerAs: '$ctrl',
    bindToController: true,
    scope: {
      model: '=?',
      name: '@',
      multiple: '<?',
      required: '<?',
    },
  }))
  .name;



// WEBPACK FOOTER //
// ./client/components/file-upload/index.js